import { render, staticRenderFns } from "./AvatarInput.vue?vue&type=template&id=8558196c&scoped=true&"
import script from "./AvatarInput.vue?vue&type=script&lang=js&"
export * from "./AvatarInput.vue?vue&type=script&lang=js&"
import style0 from "./AvatarInput.vue?vue&type=style&index=0&id=8558196c&prod&lang=sass&scoped=true&"
import style1 from "./AvatarInput.vue?vue&type=style&index=1&id=8558196c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8558196c",
  null
  
)

export default component.exports